// A list's name and description, saved together; and the task groups that use it (each gets
// the list's changes).
import { useState } from "react";
import { Link } from "react-router";
import { Button, Input, Textarea } from "rizzui";

import { useT } from "../i18n";
import { WidgetCard } from "../ui/Card";
import { type NetworkList, updateList } from "./api";
import type { ListChange } from "./useListChange";

export function DetailsCard({ list, change }: { list: NetworkList; change: ListChange }) {
  const t = useT().network.list;
  const [name, setName] = useState(list.name);
  const [description, setDescription] = useState(list.description);
  const dirty = name.trim() !== list.name || description.trim() !== list.description;
  return (
    <WidgetCard title={t.details}>
      <div className="space-y-4">
        <Input label={t.name} value={name} maxLength={100} onChange={(e) => setName(e.target.value)} />
        <Textarea label={t.description} value={description} rows={2} onChange={(e) => setDescription(e.target.value)} />
        <Button
          variant="outline"
          disabled={!dirty || name.trim() === ""}
          onClick={() => void change(() => updateList(list.id, { name: name.trim(), description: description.trim() }), () => t.saved)}
        >
          {t.save}
        </Button>
      </div>
    </WidgetCard>
  );
}

export function UsedByCard({ list }: { list: NetworkList }) {
  const t = useT().network.list;
  return (
    <WidgetCard title={t.usedBy} description={list.used_by.length > 0 ? t.usedByHint : undefined}>
      {list.used_by.length === 0 ? (
        <p className="m-0 text-sm text-gray-500">{t.notUsed}</p>
      ) : (
        <ul className="m-0 list-none space-y-1.5 p-0">
          {list.used_by.map((g) => (
            <li key={g.task_group_id}>
              <Link to={`/task-groups/${g.task_group_id}`} className="text-sm font-medium text-primary hover:underline">
                {g.name}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </WidgetCard>
  );
}
